import { render, staticRenderFns } from "./ServiceHealthTable.vue?vue&type=template&id=0ac800e1&scoped=true"
import script from "./ServiceHealthTable.vue?vue&type=script&lang=js"
export * from "./ServiceHealthTable.vue?vue&type=script&lang=js"
import style0 from "./ServiceHealthTable.vue?vue&type=style&index=0&id=0ac800e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac800e1",
  null
  
)

export default component.exports